import { INoticeGetSecure } from './../../../../models/interfaces/INotice';
import { ServiceApplication_Key } from "../../../../config/helpers";
import { ICreateUpdateNoticeDemande, INoticeDemandeGet, INoticeDemandeReturn, INoticeDetailsReturn, INoticeGet, INotices, INoticesDemandesReturn, INoticesReturn, transformNotices } from "../../../../models/interfaces/INotice";

import { IFilterNotice } from "../../../../models/interfaces/IFilterNotice";

import { apiSlice } from "../../api";
import { IFilterNoticeDemande } from "../../../../models/interfaces/IFilterNoticeDemande";
import { IFilterNoticeAapraitre } from "../../../../models/interfaces/IFilterNoticeAapraitre";

export interface noticeApiQueryBody {
    Application_Key: string;
    // eslint-disable-next-line
    Values: any;
}

export const noticeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchNotices: builder.query<INoticesReturn, IFilterNotice|undefined>({
      query: (obj) => {
        const body: noticeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };
        return {
          url: "/Notice/Notice_Search",
          method: "POST",
          body: body,
        };
      },
      transformResponse: (response: INotices) => {
        return {
          ...response,
          Notices: transformNotices(response.Notices), 
        };
      }
    }),
    fetchNotice: builder.query<INoticeDetailsReturn, INoticeGet>({
    query: ({ EAN, IdNotice }) => {
      const body: noticeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {
          EAN,
          IdNotice,
        },
      };
      return {
        url: "/Notice/Notice_Get",
        method: "POST",
        body: body,
      };
    },
  }),
  fetchNoticeSecure: builder.query<INoticeDetailsReturn, INoticeGetSecure>({
    query: ({ ParamE, ParamI }) => {
      const body: noticeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {
          ParamE,
          ParamI, 
        },
      };
      return {
        url: "/Notice/Notice_Get_Secure",
        method: "POST",
        body: body,
      };
    },
  }),
  fetchNoticeDemande: builder.query<INoticeDemandeReturn, INoticeDemandeGet>({
    query: ({ EAN, IdNotice,IdDemande }) => {
      const body: noticeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {
          EAN,
          IdNotice,
          IdDemande,
        },
      };
      return {
        url: "/Notice/NoticeDemande_Get",
        method: "POST",
        body: body,
      };
    },
  }),
  CreateUpdateNoticeDemande: builder.mutation<INoticeDemandeReturn, ICreateUpdateNoticeDemande>({
    query: (data) => {
    const body: noticeApiQueryBody = {
      Application_Key: ServiceApplication_Key,
      Values: data,
    };
    return {
      url: "/Notice/NoticeDemande_CreateUpdate",
      method: "POST",
      body: body,
    };
  },
}),
fetchNoticesDemandes: builder.query<INoticesDemandesReturn, IFilterNoticeDemande|undefined>({
  query: (obj) => {
    const body: noticeApiQueryBody = {
      Application_Key: ServiceApplication_Key,
      Values: obj,
    };
    return {
      url: "/Notice/NoticeDemande_Search",
      method: "POST",
      body: body,
    };
  },
  }),
  fetchNoticesAparaitre: builder.query<INoticesReturn, IFilterNoticeAapraitre|undefined>({
    query: (obj) => {
      const body: noticeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: obj,
      };
      return {
        url: "/Notice/Notice_Alertes_Aparaitre_Search",
        method: "POST",
        body: body,
      };
    },
    transformResponse: (response: INotices) => {
      return {
        ...response,
        Notices: transformNotices(response.Notices), 
      };
    }
  }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  //FetchCountUtilisateursQuery,
  useFetchNoticesQuery,
  useFetchNoticeQuery,
  useFetchNoticeSecureQuery,
  useFetchNoticeDemandeQuery,
  useLazyFetchNoticeDemandeQuery,
  useCreateUpdateNoticeDemandeMutation,
  useFetchNoticesDemandesQuery,
  useFetchNoticesAparaitreQuery
} = noticeApi;

